<template>
  <v-btn
    :outlined="!text"
    :text="text"
    :color="color"
    :aria-label="ariaLabel"
    class="editor-icon-btn rounded-lg"
    small
    @click="$emit('click', $event)"
  >
    <v-icon
      center
      :color="color"
      :size="iconSize"
      aria-hidden="true"
    >
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'EditorIconButton',
  props: {
    icon: { type: String, required: true },
    ariaLabel: { type: String, required: true },
    color: { type: String, default: '#9BA9BD' },
    iconSize: { type: [String, Number], default: 18 },
    text: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.editor-icon-btn {
  min-width: 30px;
  padding: 0;
}
</style>
